module.exports = __webpack_public_path__ + "static/media/dop-googl.fde80e40.svg";